import { render, staticRenderFns } from "./Facturi.vue?vue&type=template&id=9d013622&scoped=true&"
import script from "./Facturi.ts?vue&type=script&lang=ts&"
export * from "./Facturi.ts?vue&type=script&lang=ts&"
import style0 from "./Facturi.vue?vue&type=style&index=0&id=9d013622&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d013622",
  null
  
)

export default component.exports
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QIcon,QBtn});
